/* eslint func-style: "off" */
import get from 'lodash/get';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import {
  // Actions
  FETCH_TWITTER_IMPORTS,
  NEW_TWITTER_IMPORT_CAMPAIGN_SELECTION,
  NEW_TWITTER_IMPORT_SUBMIT,
  UPDATE_TWITTER_JOB_STATUS_CHANGED,
  NEW_TWITTER_IMPORT_CLOSE_MODAL,
  // Action Creators
  fetchTwitterImportsSucceeded,
  fetchTwitterImportsFailed,
  fetchProfilesSucceeded,
  fetchProfilesFailed,
  handleSubmitSucceeded,
  handleSubmitFailed,
  updateTwitterChangeStatusFailed,
  updateTwitterChangeStatusSucceeded,
  handleTwitterModalClosed
} from './TwitterImports.ducks';
import apiClient from 'helpers/apiClient';
import { convertDatePickerTimeToApiTime } from 'helpers/timeFormat';

// state selectors
export const getOffset = (state) => state.TwitterImports.offset;
export const getLimit = (state) => state.TwitterImports.limit;
export const getSelectedFilters = (state) => state.TwitterImports.selectedFilters;
export const getSelectedCampaigns = (state) => state.TwitterImports.selectedCampaign;

export const getNewImportBody = (state) => {
  const {
    accountId, jobType, startDate, endDate, selectedProfiles, estimate
  } = state.TwitterImports;
  const { timezone } = state.AppUser.user;
  const imports = Object.keys(selectedProfiles).reduce((array, b) => {
    const _profiles = map(selectedProfiles[b],({_id}) => _id);
    if(!isEmpty(_profiles)){
      array.push({
        campaignId: b,
        profileIds: map(selectedProfiles[b],({_id}) => _id)
      });
    }
    return array;
  }, []);

  return {
    accountId,
    startDate: convertDatePickerTimeToApiTime(startDate, timezone),
    endDate: convertDatePickerTimeToApiTime(endDate, timezone),
    jobType,
    data: imports,
    storyCount: estimate || null
  };
};

export const fetchTwitterImports = function* (action) {
  try {
    let offset = yield select(getOffset);
    const limit = yield select(getLimit);
    const stateSelectedFilters = yield select(getSelectedFilters);
    const selectedFilters = action.payload.selectedFilters.join(',');
    offset = isEqual(stateSelectedFilters.sort(), action.payload.selectedFilters.sort()) ? offset : 0;
    const path = `/api/twitter-imports?offset=${offset}&limit=${limit}&status=${selectedFilters}`;
    const payload = yield call(apiClient, path);
    payload.selectedFilters = action.payload.selectedFilters;
    yield put(fetchTwitterImportsSucceeded(payload));
  } catch (e) {
    yield put(fetchTwitterImportsFailed(e.body));
  }
};

export const fetchProfiles = function* () {
  try {
    const campaignIds = yield select(getSelectedCampaigns);
    const calls = campaignIds.map((e)=>{
      return call(apiClient, `/api/campaigns/${e}/profiles`);
    });
    const payload = yield all(calls);
    yield put(fetchProfilesSucceeded(payload));
  } catch (e) {
    yield put(fetchProfilesFailed(e.body));
  }
};

export const createTwitterImport = function* () {
  // Job creation
  try {
    const path = '/api/twitter-imports';
    const body = yield select(getNewImportBody);

    const payload = yield call(apiClient, path, {
      method: 'POST',
      body: JSON.stringify(body)
    });

    yield put(handleSubmitSucceeded(payload));
  } catch (e) {
    const error = get(e, 'body.error', '');
    yield put(handleSubmitFailed(error));
  }
};

export const updateTwitterChangeStatus = function* (action) {
  try {
    const path = '/api/twitter-imports';
    const payload = yield call(apiClient, path, {
      method: 'PUT',
      body: JSON.stringify(action.payload),
    });
    if (payload.status === 'error') {
      yield put(updateTwitterChangeStatusFailed(payload));
    }
    else {
      yield put(updateTwitterChangeStatusSucceeded({...action.payload, ...payload}));
    }
  } catch (e) {
    yield put(updateTwitterChangeStatusFailed(e.body));
  }
};

export const fetchTwitterImportsSaga = function* () {
  yield takeLatest( FETCH_TWITTER_IMPORTS, fetchTwitterImports);
};

export const fetchProfilesSaga = function* () {
  yield takeLatest( NEW_TWITTER_IMPORT_CAMPAIGN_SELECTION, fetchProfiles);
};

export const createTwitterImportSaga = function* () {
  yield takeLatest( NEW_TWITTER_IMPORT_SUBMIT, createTwitterImport);
};

export const updateTwitterChangeStatusSaga = function* () {
  yield takeLatest( UPDATE_TWITTER_JOB_STATUS_CHANGED, updateTwitterChangeStatus);
};

export const handleTwitterModalClose = function* () {
  yield takeLatest( NEW_TWITTER_IMPORT_CLOSE_MODAL, handleTwitterModalClosed);
};

const sagas = function* () {
  yield all([
    fork(fetchTwitterImportsSaga),
    fork(fetchProfilesSaga),
    fork(createTwitterImportSaga),
    fork(updateTwitterChangeStatusSaga),
    fork(handleTwitterModalClose),
  ]);
};

export default sagas;
